// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

import { OnDemandLearnerMaterialItemsV1 } from './OnDemandLearnerMaterialItemsV1';
import { OnDemandLearnerMaterialLessonsV1 } from './OnDemandLearnerMaterialLessonsV1';
import { OnDemandLearnerMaterialModulesV1 } from './OnDemandLearnerMaterialModulesV1';
import { OnDemandLearnerMaterialPassableLessonElementsV1 } from './OnDemandLearnerMaterialPassableLessonElementsV1';
import { OnDemandLearnerMaterialWeeksV1 } from './OnDemandLearnerMaterialWeeksV1';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export interface UserId {
  id: number;
}

export type NextStep = CourseMaterialNextStep | SwitchSessionNextStep | CourseCompletedNextStep;

export interface CourseMaterialContentSummaryTeammateReview {
  typeName: 'teammateReview';
  definition: any;
}

export interface PlaceholderItemContentSummaryDefinition {
  gradingLatePenalty?: GradingLatePenalty | null;
  learnerMessage?: string | null;
}

export interface CourseMaterialContentSummaryPlaceholder {
  typeName: 'placeholder';
  definition: PlaceholderItemContentSummaryDefinition;
}

export interface SupplementSummaryDefinition {
  assetTypeName: string;
}

export interface CourseMaterialContentSummarySupplement {
  typeName: 'supplement';
  definition: SupplementSummaryDefinition;
}

export type AssignmentFeature =
  | 'TEAMWORK'
  | 'MANUAL_GRADED_QUESTIONS'
  | 'MULTIPLE_FILLABLE_BLANKS_QUESTIONS'
  | 'WIDGET_QUESTIONS'
  | 'HIDE_GRADE_ON_RELEASE'
  | 'SHOW_GRADE_ON_RELEASE'
  | 'TAKE_LATEST_GRADE'
  | 'TAKE_HIGHEST_GRADE'
  | 'LIMITED_ATTEMPTS'
  | 'ATTEMPT_TIME_LIMITS'
  | 'LIMITED_SUBMISSIONS'
  | 'ASSIGNMENT_RUBRICS'
  | 'HIDE_LEARNER_RESPONSE_AFTER_SUBMISSION'
  | 'MULTIPLE_SUBMISSIONS'
  | 'TEXT_BLOCKS';

export interface StaffGradedSummaryDefinition {
  isTeamSubmissionEnabled: boolean;
  standardProctorConfigurationId?: string | null;
  gradingLatePenalty?: GradingLatePenalty | null;
  requiredMobileFeatures?: Array<AssignmentFeature> | null;
}

export interface CourseMaterialContentSummaryStaffGraded {
  typeName: 'staffGraded';
  definition: StaffGradedSummaryDefinition;
}

export interface UngradedWidgetSummaryDefinition {
  supportsTouch: boolean;
  minWidthPx?: number | null;
  minHeightPx?: number | null;
}

export interface CourseMaterialContentSummaryUngradedWidget {
  typeName: 'ungradedWidget';
  definition: UngradedWidgetSummaryDefinition;
}

export interface CourseMaterialContentSummaryUngradedProgramming {
  typeName: 'ungradedProgramming';
  definition: any;
}

export interface StandardPeerSummaryDefinition {
  requiredReviewCount: number;
  isMentorGraded: boolean;
}

export interface CourseMaterialContentSummaryPeer {
  typeName: 'peer';
  definition: StandardPeerSummaryDefinition;
}

export interface CourseMaterialContentSummaryUngradedLti {
  typeName: 'ungradedLti';
  definition: any;
}

export interface GradedDiscussionPromptSummaryDefinition {
  gradingLatePenalty?: GradingLatePenalty | null;
}

export interface CourseMaterialContentSummaryGradedDiscussionPrompt {
  typeName: 'gradedDiscussionPrompt';
  definition: GradedDiscussionPromptSummaryDefinition;
}

export interface LectureSummaryDefinition {
  duration?: number | null;
  hasInVideoAssessment: boolean;
}

export interface CourseMaterialContentSummaryLecture {
  typeName: 'lecture';
  definition: LectureSummaryDefinition;
}

export interface GradedWidgetSummaryDefinition {
  supportsTouch: boolean;
  minWidthPx?: number | null;
  minHeightPx?: number | null;
}

export interface CourseMaterialContentSummaryGradedWidget {
  typeName: 'gradedWidget';
  definition: GradedWidgetSummaryDefinition;
}

export interface CourseMaterialContentSummarySlideshow {
  typeName: 'slideshow';
  definition: any;
}

export interface GradedPeerSummaryDefinition {
  requiredReviewCount: number;
  isMentorGraded: boolean;
  gradingLatePenalty?: GradingLatePenalty | null;
}

export interface CourseMaterialContentSummaryGradedPeer {
  typeName: 'gradedPeer';
  definition: GradedPeerSummaryDefinition;
}

export interface AssessOpenSinglePageSummaryDefinition {
  questionCount?: number | null;
  containsWidgetQuestions: boolean;
}

export interface CourseMaterialContentSummaryAssessOpenSinglePage {
  typeName: 'assessOpenSinglePage';
  definition: AssessOpenSinglePageSummaryDefinition;
}

export interface AttemptRateLimit {
  allowedSubmissionsPerInterval: number;
  allowedSubmissionsInterval: number;
}

export interface FormativeQuizSummaryDefinition {
  questionCount: number;
  passingFraction: number;
  containsWidgetQuestions: boolean;
  requiredMobileCapabilities: Array<string>;
  maxScore: number;
  passingScore: number;
  standardProctorConfigurationId?: string | null;
  lockingConfiguration?: AttemptRateLimit | null;
}

export interface CourseMaterialContentSummaryQuiz {
  typeName: 'quiz';
  definition: FormativeQuizSummaryDefinition;
}

export interface ClosedPeerSummaryDefinition {
  requiredReviewCount: number;
  isMentorGraded: boolean;
  gradingLatePenalty?: GradingLatePenalty | null;
}

export interface CourseMaterialContentSummaryClosedPeer {
  typeName: 'closedPeer';
  definition: ClosedPeerSummaryDefinition;
}

export interface CourseMaterialContentSummaryWorkspaceLauncher {
  typeName: 'workspaceLauncher';
  definition: any;
}

export interface SingleQuestionSubmitQuizSummaryDefinition {
  questionCount?: number | null;
  containsWidgetQuestions: boolean;
}

export interface CourseMaterialContentSummarySingleQuestionSubmit {
  typeName: 'singleQuestionSubmit';
  definition: SingleQuestionSubmitQuizSummaryDefinition;
}

export interface CourseMaterialContentSummaryWiseFlow {
  typeName: 'wiseFlow';
  definition: any;
}

export interface CourseMaterialContentSummaryUngradedLab {
  typeName: 'ungradedLab';
  definition: any;
}

export interface ImmediateProgrammingSummaryDefinition {
  gradingLatePenalty?: GradingLatePenalty | null;
}

export interface CourseMaterialContentSummaryProgramming {
  typeName: 'programming';
  definition: ImmediateProgrammingSummaryDefinition;
}

export interface UngradedAssignmentSummaryDefinition {
  isTeamSubmissionEnabled: boolean;
  standardProctorConfigurationId?: string | null;
  requiredMobileFeatures?: Array<AssignmentFeature> | null;
}

export interface CourseMaterialContentSummaryUngradedAssignment {
  typeName: 'ungradedAssignment';
  definition: UngradedAssignmentSummaryDefinition;
}

export interface FixedGradingLatePenalty {
  penalty: number;
}

export interface GradingLatePenaltyFixedGradingLatePenalty {
  typeName: 'fixedGradingLatePenalty';
  definition: FixedGradingLatePenalty;
}

export type PenaltyIncrementMode =
  | 'APPLY_PENALTY_FRACTION_ON_AWARDED_SCORE'
  | 'DECREASE_PENALTY_POINTS_ON_AWARDED_SCORE';

export type PeriodType = 'ZERO' | 'MINUTE' | 'HOUR' | 'DAY' | 'WEEK' | 'MONTH' | 'INFINITY';

export interface TimePeriod {
  count: number;
  periodType: PeriodType;
}

export interface LatePenaltyIncrement {
  penalty: number;
  penaltyMode: PenaltyIncrementMode;
  applyEvery: TimePeriod;
  maxApplications?: number | null;
}

export interface LatePenaltyScoreCap {
  applyAfter: TimePeriod;
  maxFinalScore: number;
}

export interface LatePenaltyMinScoreThreshold {
  minScoreForLatePenaltyApplication: number;
}

export interface CompoundLatePenalty {
  incrementalPenalty?: LatePenaltyIncrement | null;
  maxAllowedScore?: LatePenaltyScoreCap | null;
  minScorethreshold?: LatePenaltyMinScoreThreshold | null;
}

export interface GradingLatePenaltyCompoundLatePenalty {
  typeName: 'compoundLatePenalty';
  definition: CompoundLatePenalty;
}

export interface IncrementalGradingLatePenalty {
  penalty: number;
}

export interface GradingLatePenaltyIncrementalGradingLatePenalty {
  typeName: 'incrementalGradingLatePenalty';
  definition: IncrementalGradingLatePenalty;
}

export type GradingLatePenalty =
  | GradingLatePenaltyFixedGradingLatePenalty
  | GradingLatePenaltyCompoundLatePenalty
  | GradingLatePenaltyIncrementalGradingLatePenalty;

export type GradingLatePenaltyTypeName =
  | 'fixedGradingLatePenalty'
  | 'compoundLatePenalty'
  | 'incrementalGradingLatePenalty';

export interface SummativeQuizSummaryDefinition {
  questionCount: number;
  passingFraction: number;
  containsWidgetQuestions: boolean;
  requiredMobileCapabilities: Array<string>;
  maxScore: number;
  passingScore: number;
  standardProctorConfigurationId?: string | null;
  allowedSubmissionsPerInterval: number;
  allowedSubmissionsInterval: number;
  lockingConfiguration?: AttemptRateLimit | null;
  gradingLatePenalty?: GradingLatePenalty | null;
}

export interface CourseMaterialContentSummaryExam {
  typeName: 'exam';
  definition: SummativeQuizSummaryDefinition;
}

export interface PhasedPeerSummaryDefinition {
  requiredReviewCount: number;
  isMentorGraded: boolean;
  reviewDeadlineOffset: number;
  gradingLatePenalty?: GradingLatePenalty | null;
  proctorConfigurationId?: string | null;
}

export interface CourseMaterialContentSummaryPhasedPeer {
  typeName: 'phasedPeer';
  definition: PhasedPeerSummaryDefinition;
}

export interface NotebookSummaryDefinition {
  isGradedByItem: boolean;
}

export interface CourseMaterialContentSummaryNotebook {
  typeName: 'notebook';
  definition: NotebookSummaryDefinition;
}

export interface GradedLtiSummaryDefinition {
  gradingLatePenalty?: GradingLatePenalty | null;
}

export interface CourseMaterialContentSummaryGradedLti {
  typeName: 'gradedLti';
  definition: GradedLtiSummaryDefinition;
}

export interface GradedProgrammingSummaryDefinition {
  gradingLatePenalty?: GradingLatePenalty | null;
}

export interface CourseMaterialContentSummaryGradedProgramming {
  typeName: 'gradedProgramming';
  definition: GradedProgrammingSummaryDefinition;
}

export interface CourseMaterialContentSummaryDiscussionPrompt {
  typeName: 'discussionPrompt';
  definition: any;
}

export type CourseMaterialContentSummary =
  | CourseMaterialContentSummaryTeammateReview
  | CourseMaterialContentSummaryPlaceholder
  | CourseMaterialContentSummarySupplement
  | CourseMaterialContentSummaryStaffGraded
  | CourseMaterialContentSummaryUngradedWidget
  | CourseMaterialContentSummaryUngradedProgramming
  | CourseMaterialContentSummaryPeer
  | CourseMaterialContentSummaryUngradedLti
  | CourseMaterialContentSummaryGradedDiscussionPrompt
  | CourseMaterialContentSummaryLecture
  | CourseMaterialContentSummaryGradedWidget
  | CourseMaterialContentSummarySlideshow
  | CourseMaterialContentSummaryGradedPeer
  | CourseMaterialContentSummaryAssessOpenSinglePage
  | CourseMaterialContentSummaryQuiz
  | CourseMaterialContentSummaryClosedPeer
  | CourseMaterialContentSummaryWorkspaceLauncher
  | CourseMaterialContentSummarySingleQuestionSubmit
  | CourseMaterialContentSummaryWiseFlow
  | CourseMaterialContentSummaryUngradedLab
  | CourseMaterialContentSummaryProgramming
  | CourseMaterialContentSummaryUngradedAssignment
  | CourseMaterialContentSummaryExam
  | CourseMaterialContentSummaryPhasedPeer
  | CourseMaterialContentSummaryNotebook
  | CourseMaterialContentSummaryGradedLti
  | CourseMaterialContentSummaryGradedProgramming
  | CourseMaterialContentSummaryDiscussionPrompt;

export type CourseMaterialContentSummaryTypeName =
  | 'teammateReview'
  | 'placeholder'
  | 'supplement'
  | 'staffGraded'
  | 'ungradedWidget'
  | 'ungradedProgramming'
  | 'peer'
  | 'ungradedLti'
  | 'gradedDiscussionPrompt'
  | 'lecture'
  | 'gradedWidget'
  | 'slideshow'
  | 'gradedPeer'
  | 'assessOpenSinglePage'
  | 'quiz'
  | 'closedPeer'
  | 'workspaceLauncher'
  | 'singleQuestionSubmit'
  | 'wiseFlow'
  | 'ungradedLab'
  | 'programming'
  | 'ungradedAssignment'
  | 'exam'
  | 'phasedPeer'
  | 'notebook'
  | 'gradedLti'
  | 'gradedProgramming'
  | 'discussionPrompt';

export type ItemLockedReasonCode =
  | 'PREMIUM'
  | 'PASSABLE_ITEM_COMPLETION'
  | 'PREMIUM_ITEM'
  | 'SESSION_PREVIEW'
  | 'SESSION_ENDED'
  | 'SESSION_ENDED_FOR_FLEXIBLE_SCHEDULE'
  | 'ENROLLMENT_PREVIEW'
  | 'RESTRICTED_AUDIT'
  | 'TIMED_RELEASE_CONTENT'
  | 'TIMED_SUBMISSION_LOCKED_CONTENT'
  | 'RESITTING_ITEM_LOCK_OVERRIDE';

export type ItemLockStatus = 'LOCKED_PARTIALLY_FOR_SUBMITTING' | 'LOCKED_FOR_SUBMITTING' | 'LOCKED_FULLY';

export interface ItemLockState {
  lockStatus: ItemLockStatus;
  reasonCode: ItemLockedReasonCode;
}

export interface TimedReleaseContentLockInfo {
  unlockedTimeStart?: number | null;
  unlockedTimeEnd?: number | null;
  timedItemLockCustomMessage?: string | null;
}

export interface ItemLockInfoTimedReleaseContentLockInfo {
  typeName: 'timedReleaseContentLockInfo';
  definition: TimedReleaseContentLockInfo;
}

export type ItemLockInfo = ItemLockInfoTimedReleaseContentLockInfo;

export type ItemLockInfoTypeName = 'timedReleaseContentLockInfo';

export interface ItemLockSummary {
  lockState: ItemLockState;
  lockInfo?: ItemLockInfo | null;
  isPreviewableByCourseStaff?: boolean | null;
}

export interface CourseMaterialItem {
  moduleId: string;
  lessonId: string;
  name: string;
  slug: string;
  timeCommitment: number;
  contentSummary: CourseMaterialContentSummary;
  lockableByItem?: string | null;
  isLocked: boolean;
  itemLockedReasonCode?: ItemLockedReasonCode | null;
  trackId: string;
  isCustomContent: boolean;
  lockedStatus?: ItemLockStatus | null;
  itemLockSummary?: ItemLockSummary | null;
}

export type LearnerCourseOnTrackStatus = 'OnTrack' | 'SingleDeadlineOverdue' | 'MultipleDeadlinesOverdue';

export interface CourseMaterialNextStep {
  passableItemId: string;
  passableItemDetails: CourseMaterialItem;
  preparatoryItemId?: string | null;
  preparatoryItemDetails?: CourseMaterialItem | null;
  dueAt?: number | null;
  isOverdue?: boolean | null;
  courseOnTrackStatus: LearnerCourseOnTrackStatus;
  passableLessonElementId: string;
}

export type SwitchSessionReason = 'MultipleDeadlinesOverdue' | 'NotEnoughPeerReviews' | 'SessionEnded';

export interface SwitchSessionNextStep {
  reason: SwitchSessionReason;
  activeSessionId: string;
  nextEnrollableSessionId?: string | null;
}

export type CourseCompletedNextStep =
  | 'ViewCertificate'
  | 'CompleteVerificationProfile'
  | 'BuyCourse'
  | 'EligibleButNoCertificate'
  | 'NoVcCourseCompleted';

export interface OnDemandLearnerMaterialsV1 {
  id: string;
  userId: UserId;
  learnerMaterialLessonElementIds: Array<string>;
  lessonElementIds: Array<string>;
  learnerMaterialItemIds: Array<string>;
  itemIds: Array<string>;
  passableItemGroupIds: Array<string>;
  learnerMaterialLessonIds: Array<string>;
  lessonIds: Array<string>;
  learnerMaterialModuleIds: Array<string>;
  moduleIds: Array<string>;
  learnerMaterialWeekNumbers: Array<string>;
  weekNumbers: Array<number>;
  totalPassablesCount: number;
  totalEvaluablesCount: number;
  totalQuizzesCount: number;
  totalPhasedPeerItemsCount: number;
  totalLectureDuration: number;
  isPassable: boolean;
  isEvaluable: boolean;
  totalDuration?: number | null;
  totalLecturesCount?: number | null;
  totalSupplementsCount?: number | null;
  courseId: string;
  isPassedOrCompleted?: boolean | null;
  isDeadlineWorkDone?: boolean | null;
  isAllWorkDone?: boolean | null;
  isOverallPassed?: boolean | null;
  overallGrade?: number | null;
  isVerifiedPassed?: boolean | null;
  verifiedGrade?: number | null;
  passedAllPassablesCount?: number | null;
  passedCorePassablesCount?: number | null;
  passedAllPassablesPercentage?: number | null;
  passedCorePassablesPercentage?: number | null;
  completedAllEvaluablesCount?: number | null;
  completedCoreEvaluablesCount?: number | null;
  completedAllEvaluablesPercentage?: number | null;
  completedCoreEvaluablesPercentage?: number | null;
  doneAllPassablesCount?: number | null;
  doneCorePassablesCount?: number | null;
  doneAllPassablesPercentage?: number | null;
  doneCorePassablesPercentage?: number | null;
  doneAllEvaluablesCount?: number | null;
  doneCoreEvaluablesCount?: number | null;
  doneAllEvaluablesPercentage?: number | null;
  doneCoreEvaluablesPercentage?: number | null;
  summaryCoreProgressPercentage?: number | null;
  isProgressCritical?: boolean | null;
  nextStep?: NextStep | null;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface OnDemandLearnerMaterialsV1Connection {
  elements: Array<OnDemandLearnerMaterialsV1> | null;
  linked: {
    onDemandLearnerMaterialWeeksV1: Array<OnDemandLearnerMaterialWeeksV1> | null;
    onDemandLearnerMaterialItemsV1: Array<OnDemandLearnerMaterialItemsV1> | null;
    onDemandLearnerMaterialModulesV1: Array<OnDemandLearnerMaterialModulesV1> | null;
    onDemandLearnerMaterialLessonsV1: Array<OnDemandLearnerMaterialLessonsV1> | null;
    onDemandLearnerMaterialPassableLessonElementsV1: Array<OnDemandLearnerMaterialPassableLessonElementsV1> | null;
  } | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface OnDemandLearnerMaterialsV1CourseSlugsQuery {
  OnDemandLearnerMaterialsV1: {
    courseSlugs: OnDemandLearnerMaterialsV1Connection | null;
  } | null;
}

export interface OnDemandLearnerMaterialsV1CourseSlugsQueryVariables {
  courseSlugs: string;
  includes?: string | null;
}

export interface OnDemandLearnerMaterialsV1CoursesQuery {
  OnDemandLearnerMaterialsV1: {
    courses: OnDemandLearnerMaterialsV1Connection | null;
  } | null;
}

export interface OnDemandLearnerMaterialsV1CoursesQueryVariables {
  courseIds: string;
  anonymousAccess?: string | null;
  includes?: string | null;
}

export interface OnDemandLearnerMaterialsV1GetQuery {
  OnDemandLearnerMaterialsV1: {
    get: OnDemandLearnerMaterialsV1Connection | null;
  } | null;
}

export interface OnDemandLearnerMaterialsV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

export interface OnDemandLearnerMaterialsV1MultiGetQuery {
  OnDemandLearnerMaterialsV1: {
    multiGet: OnDemandLearnerMaterialsV1Connection | null;
  } | null;
}

export interface OnDemandLearnerMaterialsV1MultiGetQueryVariables {
  ids: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class OnDemandLearnerMaterialsV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'onDemandLearnerMaterials.v1' as const;

  declare id: string;

  declare userId: UserId;

  declare learnerMaterialLessonElementIds: Array<string>;

  declare lessonElementIds: Array<string>;

  declare learnerMaterialItemIds: Array<string>;

  declare itemIds: Array<string>;

  declare passableItemGroupIds: Array<string>;

  declare learnerMaterialLessonIds: Array<string>;

  declare lessonIds: Array<string>;

  declare learnerMaterialModuleIds: Array<string>;

  declare moduleIds: Array<string>;

  declare learnerMaterialWeekNumbers: Array<string>;

  declare weekNumbers: Array<number>;

  declare totalPassablesCount: number;

  declare totalEvaluablesCount: number;

  declare totalQuizzesCount: number;

  declare totalPhasedPeerItemsCount: number;

  declare totalLectureDuration: number;

  declare isPassable: boolean;

  declare isEvaluable: boolean;

  declare totalDuration?: number | null;

  declare totalLecturesCount?: number | null;

  declare totalSupplementsCount?: number | null;

  declare courseId: string;

  declare isPassedOrCompleted?: boolean | null;

  declare isDeadlineWorkDone?: boolean | null;

  declare isAllWorkDone?: boolean | null;

  declare isOverallPassed?: boolean | null;

  declare overallGrade?: number | null;

  declare isVerifiedPassed?: boolean | null;

  declare verifiedGrade?: number | null;

  declare passedAllPassablesCount?: number | null;

  declare passedCorePassablesCount?: number | null;

  declare passedAllPassablesPercentage?: number | null;

  declare passedCorePassablesPercentage?: number | null;

  declare completedAllEvaluablesCount?: number | null;

  declare completedCoreEvaluablesCount?: number | null;

  declare completedAllEvaluablesPercentage?: number | null;

  declare completedCoreEvaluablesPercentage?: number | null;

  declare doneAllPassablesCount?: number | null;

  declare doneCorePassablesCount?: number | null;

  declare doneAllPassablesPercentage?: number | null;

  declare doneCorePassablesPercentage?: number | null;

  declare doneAllEvaluablesCount?: number | null;

  declare doneCoreEvaluablesCount?: number | null;

  declare doneAllEvaluablesPercentage?: number | null;

  declare doneCoreEvaluablesPercentage?: number | null;

  declare summaryCoreProgressPercentage?: number | null;

  declare isProgressCritical?: boolean | null;

  declare nextStep?: NextStep | null;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<OnDemandLearnerMaterialsV1>) {
    super(params);
  }
}
